document.addEventListener("DOMContentLoaded", ()=>{

    let currentVarName
    let currentPantsVarName;
    let initalPrice
    const currencySymbol = GEBO.settings.shop_money_format[0];
    document.addEventListener("click", (e)=>{
        if(e.target.closest(".sock-option")){
          try{

            let input = e.target.closest(".sock-option").querySelector("input");
            let varName = input.value
            currentVarName = varName;
          }catch(error){
            console.error(error.message);
          }
        }
        if(e.target.closest(".sc-sock-choice")){
          try{
            // if(e.target.closest("#both-sock-choice")){
            //   // let price = secondPrice;
            //   const priceDiv = e.target.closest("#product-content-wrapper").querySelector("#prod-price");
            //   priceDiv.innerHTML =   price
            // }else{
            //   let price = initalPrice;
            //   const priceDiv = e.target.closest("#product-content-wrapper").querySelector("#prod-price");
            //   priceDiv.innerHTML =  price

            // }
            if(!currentVarName) return
            const selector = e.target.closest(".sc-sock-choice").dataset.selector;
            const div = document.getElementById(selector);
            const options = Array.from(div.querySelectorAll("input"));
            const activeInput = options.find((input)=>{
              return input.value == currentVarName
            })
            
            if(activeInput && !activeInput.closest(".sock-option").classList.contains("variant-oos")){
              activeInput.checked = true;
            }
            if(activeInput.closest(".sock-option").classList.contains("variant-oos")){
              oldInput = document.querySelector(".sock-variant-options input:checked");
              if(oldInput){
                
                oldInput.checked = false;
              }
            }
            updateSockChoiceState(e);
          }catch(error){
            console.error(error)
          }
        }
        
        if(e.target.closest(".sc-prod-choice")){
          let activeOption
          const newChoice = e.target.closest(".sc-prod-choice").dataset.type;
          const outerWrapper = e.target.closest("#sc-prod-types-outer-wrapper");
          const options = outerWrapper.querySelectorAll(".sc-pants-wrapper");
          Array.from(options).forEach((option)=>{
              if(option.dataset.productType == newChoice){
                activeOption = option
                option.style.display = "block"
              }else{
                option.style.display = "none";
              }
          })

          if(!currentPantsVarName) return;
          const prevInput = e.target.closest("#sc-prod-types-outer-wrapper").querySelector(".sc-options-wrapper input:checked");
          if(prevInput){
            prevInput.checked  = false
          }
          const inputs = activeOption.querySelectorAll("input");
          Array.from(inputs).forEach((input)=>{
            if(input.value == currentPantsVarName){
              if(!input.closest("label").classList.contains("variant-oos")){
                input.checked = true;//123
              }
            }
          })
          

        }

        if(e.target.closest(".sc-options-wrapper")){
          if(e.target.closest("label")){
            const varname = e.target.closest("label").querySelector("input").value;
            currentPantsVarName = varname;
          }
        }

        if(e.target.closest("#sc-complete")){
          e.stopPropagation();
    e.preventDefault();
          let toAdd = [];
          const selectedPants = document.querySelectorAll(".sc-pants-options input:checked");
          console.log(selectedPants)
          selectedPants.forEach((pants)=>{
            console.log(pants)
            let varId = pants.dataset.varId;
            toAdd.push(varId)
          })
            const checkedSocks = document.querySelector("#sock-variant-wrapper input:checked");
            if(checkedSocks.classList.contains("dual-socks")){
                const var1 = checkedSocks.dataset.varIdOne;
                const var2 = checkedSocks.dataset.varIdTwo;
                toAdd.push(var1,var2);
            }else{
                const varId = checkedSocks.dataset.varId;
                toAdd.push(varId)
            }
            addSockBundleToCart(toAdd)
            

        }
    })

    const getProdType = () => {
      let sockType = document.querySelector("#plain-sock-choice input:checked") ? "B" : "A";
      const pantsWrappers = document.querySelectorAll(".sc-pants-wrapper")
      let prodTypes = [];
      Array.from(pantsWrappers).forEach((wrapper)=>{
        const checkedInput = wrapper.querySelector("input:checked");

        if (checkedInput) {
          prodTypes.push(wrapper.dataset.productType);
        }
      })
      let url = ``
      prodTypes.forEach((type, index)=>{
        let formattedType = index > 0   ? type.split(" ").at(-1) : type;
        if(formattedType.toLowerCase().includes("bamboo")){
          formattedType = "Bamboo"
        }
        formattedType = formattedType.replace("Ladies","Womens");
        formattedType = formattedType.replace("Low Rise","Womens")
        url = url + formattedType.replace(/ /g, "") + "-";
      })
      url = "https://cdn.shopify.com/s/files/1/0353/7249/files/" + url + "1-Sock-" + sockType + ".png";
      console.log(url)
      return url
    }

    function updateSockChoiceState(e = null) {
      const wrapper = e? e.target.closest("#sock-choice-outer-wrapper") : document.getElementById('sock-choice-outer-wrapper');
      console.log(wrapper)
      if (!wrapper) return;
    initalPrice = wrapper.querySelector(".sock-bundle-price")?.innerHTML;
      const pantsGroups = wrapper.querySelectorAll('.sc-pants-options');

    let pantsSelected = [...pantsGroups].every(group =>
      group.querySelector('input:checked')
    );
    if(document.getElementById("sc-prod-types-outer-wrapper")){
      pantsSelected = document.querySelector(".sc-pants-wrapper.bralette-wrapper input:checked") && document.querySelector("#sc-prod-types-outer-wrapper .sc-options-wrapper input:checked")
    }



      const sockSelected = wrapper.querySelector('#sock-variant-wrapper input:checked');
      console.log(wrapper.querySelector("#sock-variant-wrapper input:checked"))

      const isComplete = !!pantsSelected && !!sockSelected;

      wrapper.classList.toggle('is-complete', isComplete);
    }

    updateSockChoiceState();
    
    document.addEventListener('change', (e) => {
      if (
        e.target.matches('.sc-pants-options input, #sock-variant-wrapper input, .sc-prod-types-wrapper input')
        
      ) {
        updateSockChoiceState(e);
      }
    });


    const addSockBundleToCart = async (ids) => {
      const wrapper = document.getElementById('sock-choice-outer-wrapper');
      wrapper.classList.remove("is-complete")
      wrapper.classList.add("is-loading")
      let timeStamp = Date.now()
      const bundleId = document.getElementById("prod-first-var-input").value;
      const prodImage = getProdType()
      console.log(prodImage)
      for(let i =0; i<ids.length; i++){
        await(addToCart({varId: ids[i], quantity:1, properties:{"_bundleId": timeStamp, "_bundleVariantId": bundleId, "_bundleImage": prodImage}}))
      }
      const resetRevent = new CustomEvent('revertToCart');
      document.dispatchEvent(resetRevent);
      
      const cartevent = new CustomEvent('updateCart');
      document.dispatchEvent(cartevent);
      wrapper.classList.add("is-complete")
      wrapper.classList.remove("is-loading")
    }

const addToCart = async (options = {}) => {
  const normalizedOptions = {
    varId: options.varId,
    quantity: options.quantity || 1,
    properties: options.properties || {},
    productId: options.productId || "",
    productTitle: options.productTitle || ""
  };

  if (!normalizedOptions.varId || !normalizedOptions.quantity) {
    throw new Error("varId and quantity are required");
  }

  const form = createForm(normalizedOptions);
  const formLoc = document.getElementById("atc-form-loc");

  if (!formLoc) {
    throw new Error("no atc form location");
  }

  formLoc.append(form);

  const formData = new FormData(form);
  const dataString = new URLSearchParams(formData).toString();

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Accept": "application/json",
    },
    body: dataString,
  });

  if (!response.ok) {
    const json = await response.json();
    throw new Error(json.description || "Failed to add to cart");
  }

  const cartItem = await response.json();

  document.dispatchEvent(
    new CustomEvent("itemAddedToCart", {
      detail: {
        variant: normalizedOptions.varId,
        cartItem,
        formData,
      },
    })
  );

  return cartItem;
};


const createForm = ({
  varId,
  quantity,
  properties,
  productId,
  productTitle,
  productPrice
}) => {
    const newFormProps = Object.fromEntries(
        Object.entries(properties).map(([key, value]) => [
            `properties[${key}]`,
            value
        ])
    );


    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.id = `product-form-${productId}`;
    form.acceptCharset = 'UTF-8';
    form.className = "product-form hidden";
    form.enctype = 'multipart/form-data';
    form.setAttribute('data-product-id', productId);
    form.setAttribute('novalidate', 'novalidate');
    form.setAttribute('data-type', 'add-to-cart-form');
    const formProps = {
        ...newFormProps,
        "form_type": "product",
        "utf8": "✓",
        "id":varId,
        "quantity": quantity,
        "product-id": productId,
    }
    Object.entries(formProps).forEach(([name, value]) => {
        if (value === undefined || value === null) return;

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = String(value);
        form.appendChild(input);
    });
    const atcButton = document.createElement('button');
    atcButton.type = 'submit';
    atcButton.classList.add('add-to-cart-button', 'hidden');
    form.appendChild(atcButton);
    form.addEventListener('submit', function(event) {
        event.preventDefault();
    });
    return form;

};



})